// 简体中文表格（机器翻译，未经人工审校 — ruling G4）。
// The Simplified Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const ART_GONE = 'This art is too detailed for the size — enlarge it';
const BASE_PIECES = 'Parts on the tag sit too far apart to bridge a base — add a base margin, bring them closer, or shrink the art';
const INTERNAL = 'Something went wrong — try again';
const FATAL = 'Could not load the model builder — refresh the page';
const S = {
  title: "四层名牌",
  cap: "字母高度（毫米）",
  spacing: "字母间距",
  textHint: "按 Enter 换行 · 最多 3 行",
  dir: {
    h: "横排",
    v: "竖排",
  },
  align: {
    h: {
      start: "左",
      center: "居中",
      end: "右",
    },
    v: {
      start: "顶部",
      center: "中间",
      end: "底部",
    },
  },
  lineGap: "行距",
  layers: "颜色分层",
  layerCount: "层数",
  base: "底座",
  ring: "边缘",
  textLayer: "字母",
  width: "宽度",
  height: "厚度",
  mm: " 毫米",
  looks: "配色",
  loop: "钥匙链挂孔",
  pos: {
    none: "无",
    left: "左",
    right: "右",
    top: "顶部",
  },
  hole: "孔宽",
  ringW: "挂环边",
  print: "打印",
  layerHeight: "层高",
  mode: {
    multi: "多色（CFS / AMS）",
    swap: "单喷头，按层换色",
  },
  zTable: (color, z, layer) => `在 ${z.toFixed(2)} 毫米处（第 ${layer} 层）切换到 ${color}`,
  size: (w, h, z) => `${w.toFixed(1)} × ${h.toFixed(1)} × ${z.toFixed(1)} 毫米`,
  dlstl: "下载 STL",
  copied: "已复制",
  stillBuilding: "仍在生成——较长的多行文字可能需要约一分钟",
  loadingFont: (got, total) => `正在加载字体 ${got.toFixed(1)} / ${total.toFixed(1)} MB`,
  notice: {
    loadFailed: (family) => `无法加载 ${family}——请检查网络连接 · 继续使用当前字体`,
    capRaised: (family, cap) => `字母高度已设为 ${cap} 毫米——这是 ${family} 能清晰打印的最小尺寸`,
  },
  issue: {
    "missing-glyph": (p) => `字体 ${String(p.font).replace(/@\d+$/, '')} 缺少这些字符：${p.chars.join(' ')}`,
    "thin-ring": (p) => `第 ${p.band + 1} 层的边缘太薄（${p.w} 毫米）——应不小于 0.8 毫米`,
    "thin-stroke": (p) => p.minCap
      ? `此字体从 ${p.minCap} 毫米起才能清晰打印——请把字母高度提到至少 ${p.minCap} 毫米`
      : `${p.chars.join(' ')} 的笔画比 0.4 毫米喷嘴还细——请放大或选更粗的字体`,
    "bed-fit": (p) => `牌子为 ${p.w.toFixed(0)} × ${p.h.toFixed(0)} 毫米——可能超出 220 毫米打印床`,
    "loop-float": () => '挂孔没有连在牌子上——请移动它或加大底座边距',
    "thin-art": () => '图案的部分笔画比 0.4 毫米喷嘴还细——请放大或换笔画更粗的图案',
    "icon-max": (p) => `图案最大可为 ${p.max} 毫米——已按该尺寸显示`,
    "art-gone": () => '图案对这个尺寸来说太精细——请放大图案',
    "base-pieces": () => '牌子上的部件相距太远，底座无法连接——请加大底座边距、拉近部件或缩小图案',
  },
  errorCode: {
    "build-timeout": "生成 2 分钟未完成，已重新开始——请减少字母或换字体",
    stale: "有更新的修改到来",
    empty: "没有可打印的字母",
    "font-load": "字体未能加载",
    internal: "出了点问题——请重试",
    "base-pieces": "牌子上的部件相距太远，底座无法连接——请加大底座边距、拉近部件或缩小图案",
    "art-gone": "图案对这个尺寸来说太精细——请放大",
    engine: "出了点问题——请重试",
    fatal: "无法加载模型生成器——请刷新页面",
  },
  fatal: "无法加载模型生成器——请刷新页面",
  icon: "图案或标志（SVG）",
  unpick: "移除图案",
  iconPos: {
    left: "左",
    right: "右",
    above: "上方",
  },
  iconSize: "图案大小",
  iconGap: "间隙",
  pct: (k) => `${Math.round(k * 100)}%`,
  needFile: "选择图案或标志的 SVG 文件——它只留在您的设备上，不会发送到任何地方",
  artKept: "图案只存在于当前标签页——刷新后需重新选择文件",
  keptOld: "（仍在使用先前的图案）",
  thumb: "已读取图案的预览",
  shareNoIcon: "此链接不带图案文件——打开的人需要自行选择 SVG",
  linkNeedsIcon: "此设计使用了文件里的图案，但链接不带该文件——请选择 SVG 文件补上",
  aboutP: "设计 2–4 色的名牌或钥匙扣。名字支持泰文、英文、中文或日文，可多行或竖排，自选字体，下载多色打印用的 3MF 或单色打印用的 STL。浏览器里免费用，无需安装。还可以把 SVG 文件的标志或图标放在名字旁边 — 文件只留在你的设备上，不会被发送到任何地方。",
};
export default S;
